import {
    PublicClientApplication,
    AuthenticationResult,
    AccountInfo,
    EndSessionRequest,
    RedirectRequest,
    PopupRequest,
    SilentRequest,
    AuthorizationCodeRequest,
} from "@azure/msal-browser";

import { MSAL_CONFIG } from "src/azure/azure-authentication-config";

const AzureActiveDirectoryAppClientId: any = process.env.REACT_APP_MS_CLIENT_ID;
const redirectURL = process.env.REACT_APP_SERVER_MS_REDIRECT_URL;
const TenantId: any = process.env.REACT_APP_MS_TENANT_ID;

export class AzureAuthenticationRedirectContext {
    private myMSALObj: PublicClientApplication = new PublicClientApplication(MSAL_CONFIG);
    private silentRequest? : SilentRequest;

    async login(setUser: any) {
        const redirectResponse = await this.myMSALObj.handleRedirectPromise();
        if (redirectResponse !== null) {
            const accessToken = redirectResponse.accessToken;
            // login.tsx에 originOnToken이다 
            setUser(accessToken);
        } else {
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            const setAccount : AccountInfo  = {tenantId : TenantId}; 
            await this.myMSALObj.acquireTokenSilent({scopes : ["User.Read"],forceRefresh : false,  account : setAccount}).then(function(accessTokenResponse) {
                const accessToken = accessTokenResponse.accessToken;
                setUser(accessToken);
            }).catch(() =>{
                this.myMSALObj.acquireTokenRedirect({scopes : ["User.Read"]})
            })
        }
    }

}

export default AzureAuthenticationRedirectContext;